import { createFcmContext } from 'src/app/shared/contexts/fcm';
import type { LoadedStateData } from 'src/app/shared/utils/async';

export const {
	FcmContext: DecisionMakerResponsePageFcmContext,
	FcmProvider: DecisionMakerResponsePageFcmContextProvider,
	useFcm: useDecisionMakerResponsePageFcm,
	useAsyncFcm: useAsyncDecisionMakerResponsePageFcm,
	prefetchFcm: prefetchDecisionMakerResponsePageFcm,
} = createFcmContext({
	name: 'DecisionMakerResponsePageFcmContext',
	dataProperty: 'pageFcm',
	configs: {},
	prefetch: true,
});

export type DecisionMakerResponsePageFcmState = ReturnType<typeof useAsyncDecisionMakerResponsePageFcm>;
export type DecisionMakerResponsePageFcm = LoadedStateData<DecisionMakerResponsePageFcmState>;
